import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ExternalLink, ChevronRight } from "lucide-react";
import { pageCta, MYSPORTS_URL } from "../../data/content";

const NAV = [["Kurse", "/kurse", "kurse"], ["Kursplan", "/kursplan", "kursplan"], ["Coaching", "/coaching", "coaching"], ["Preise", "/preise", "preise"], ["Firmenfitness", "/firmenfitness", "firmenfitness"], ["Über uns", "/ueber-uns", "ueber-uns"], ["Kontakt", "/#kontakt", "kontakt"]];

export const Logo = ({ white = false }) => (
  <Link to="/" data-testid="logo-link" className="block">
    <img src={white ? "/logo-white.webp" : "/logo-black.webp"} alt="FlensFitness" width={160} height={32} className="h-7 md:h-8 w-auto" />
  </Link>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname, hash } = useLocation();
  const cta = pageCta(pathname);
  useEffect(() => { setOpen(false); }, [pathname, hash]);
  useEffect(() => {
    if (!open) return;
    const close = (event) => { if (event.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', close);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { window.removeEventListener('keydown', close); document.body.style.overflow = prev; };
  }, [open]);
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[#F7F6F3]/85 backdrop-blur-xl border-b border-[#E6E3DD]">
      <div className="max-w-[1320px] mx-auto px-5 md:px-10 h-[72px] flex items-center justify-between">
        <Logo />
        <nav aria-label="Hauptnavigation" className="hidden lg:flex items-center gap-4 xl:gap-6 mx-6 whitespace-nowrap">
          {NAV.map(([label, to, key, short]) => (
            <Link key={to} to={to} data-testid={`nav-${key}`} aria-current={pathname === to ? 'page' : undefined} className={`font-head text-[13px] xl:text-sm font-medium hover:text-[#BA00C5] transition-colors ${pathname === to ? 'text-[#8A0093]' : 'text-[#3A3A3E]'}`}>{short ? <><span className="xl:hidden">{short}</span><span className="hidden xl:inline">{label}</span></> : label}</Link>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a href={MYSPORTS_URL} target="_blank" rel="noopener noreferrer" data-testid="header-book-btn" title="Tageskarte 18 €, ohne Vertrag" className="btn-ghost hidden md:inline-flex lg:hidden xl:inline-flex !py-3 !px-4 !text-sm whitespace-nowrap">Kurs buchen <ExternalLink size={14} /></a>
          <button data-testid="header-cta-btn" onClick={cta.run} className="btn-accent hidden sm:inline-flex !py-3 !px-5 whitespace-nowrap">
            {cta.label === "Kostenloses Probetraining" ? <><span className="lg:hidden xl:inline">Kostenloses Probetraining</span><span className="hidden lg:inline xl:hidden">Probetraining</span></> : cta.label}
          </button>
          <button data-testid="mobile-menu-btn" className="lg:hidden p-2" onClick={() => setOpen(!open)} aria-label={open ? "Menü schließen" : "Menü öffnen"} aria-expanded={open} aria-controls="mobile-navigation">
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      {open && (
        <nav id="mobile-navigation" aria-label="Mobile Hauptnavigation" className="lg:hidden absolute inset-x-0 top-full h-[calc(100dvh-72px)] z-40 overflow-y-auto border-t border-[#E6E3DD] bg-[#F7F6F3] px-5 pt-4 pb-[max(1.5rem,env(safe-area-inset-bottom))] flex flex-col">
          <div className="flex flex-col divide-y divide-[#E6E3DD]">
            {NAV.map(([label, to, key]) => (
              <Link key={to} to={to} onClick={() => setOpen(false)} data-testid={`mobile-nav-${key}`} aria-current={pathname === to ? 'page' : undefined} className={`flex items-center justify-between py-4 font-head text-lg font-semibold ${pathname === to ? 'text-[#8A0093]' : ''}`}>{label}<ChevronRight size={18} className="text-[#9A9AA0]" /></Link>
            ))}
          </div>
          <div className="mt-auto pt-6 grid gap-3">
            <button data-testid="mobile-nav-cta" onClick={() => { setOpen(false); cta.run(); }} className="btn-accent w-full justify-center">{cta.label}</button>
            <a href={MYSPORTS_URL} target="_blank" rel="noopener noreferrer" data-testid="mobile-nav-book" className="btn-ghost w-full justify-center !text-sm">Kurs buchen · Tageskarte 18 € <ExternalLink size={14} /></a>
          </div>
        </nav>
      )}
    </header>
  );
};
